import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Badge, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { MIcon } from '../../../../@material-extend';

const AvatarMenuItem = ({ icon, text, to, onClick, id, badgeContent }) => (
  <MenuItem key="demands" draggable="false" component={to && RouterLink} to={to} onClick={onClick} id={id}>
    <ListItemIcon>
      <MIcon icon={icon} variant="neutral-faded" />
    </ListItemIcon>
    <ListItemText>{text}</ListItemText>
    {badgeContent !== undefined && badgeContent !== 0 && (
      <Badge
        badgeContent={badgeContent}
        color="error"
        sx={{
          marginLeft: 'auto',
          '& .MuiBadge-badge': {
            top: '50%',
            right: -6,
            transform: 'translateY(-50%)'
          }
        }}
      />
    )}
  </MenuItem>
);

AvatarMenuItem.propTypes = {
  icon: PropTypes.string,
  to: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  badgeContent: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default AvatarMenuItem;
